import { Component, Input, OnInit } from '@angular/core';
import { InviteService } from 'src/app/services/modelService/invite.service';
import { MasterService } from 'src/app/services/modelService/master.service';

@Component({
  selector: 'app-master-dropdown',
  templateUrl: './master-dropdown.component.html',
  styleUrls: ['./master-dropdown.component.scss'],
})
export class MasterDropdownComponent implements OnInit {

  @Input() label;
  @Input() parent;
  @Input() master;
  @Input() level;
  @Input() category;
  @Input() extraVariable;
  constructor(public requestService: InviteService, public masterService: MasterService) { }

  ngOnInit() { }

}
